module.exports = __webpack_public_path__ + "img/amio_chat_with_beak.9938a504.svg";